module.exports = __webpack_public_path__ + "static/kv-demopage-3d1f713dcb9662fe0bddc765463af50f.png";